import { VITAMINS_AND_SUPPLEMENTS } from './vitaminsAndSupplements';

export const FOOD_SENSITIVITY_TEST_SLUGS = [
  'food-sensitivity',
  'food-sensitivity-expansion',
];

export const PRODUCT_SLUGS = {
  FOOD_SENSITIVITY_PKI: 'food-sensitivity',
  FOOD_SENSITIVITY_COMPREHENSIVE: 'food-sensitivity-comprehensive-test',
  WOMENS_HEALTH: 'womens-health-test',
  THYROID: 'thyroid-test',
  COVID: 'covid-19-test',
  COVID_ELLUME: 'covid-ellume-rapid-test',
  COVID_QUIDEL: 'covid-quidel-rapid-test',
  COVID_BD: 'covid-bd-veritor-rapid-test',
};

export const VARIANT_SKUS = {
  COVID: 'covid-19-ew',
  COVID_BD: 'covid-bd-veritor-rapid-test',
};

/**
 * top 5 product IDs in order
 */
export const top5 = [
  PRODUCT_SLUGS.FOOD_SENSITIVITY_PKI,
  PRODUCT_SLUGS.FOOD_SENSITIVITY_COMPREHENSIVE,
  PRODUCT_SLUGS.COVID,
  PRODUCT_SLUGS.WOMENS_HEALTH,
  PRODUCT_SLUGS.THYROID,
];

export const COVID_SLUGS = [
  PRODUCT_SLUGS.COVID,
  PRODUCT_SLUGS.COVID_ELLUME,
  PRODUCT_SLUGS.COVID_QUIDEL,
  PRODUCT_SLUGS.COVID_BD,
];

export const NY_ALLOWED_SKUS = [
  VARIANT_SKUS.COVID_BD,
  VARIANT_SKUS.COVID,
  ...VITAMINS_AND_SUPPLEMENTS,
];

export const PHONE_NUMBER_NEEDED_SKUS = [VARIANT_SKUS.COVID];
